// Frontend entry point: wires Alpine.js (bundled from npm, not a CDN) and
// registers the interactive stores/components the admin shell needs.
import Alpine from "alpinejs";
import { registerShell } from "./shell";
import { registerSignature } from "./signature";
import { registerDatepicker } from "./datepicker";
import { initLeadSections } from "./sections";
import { initLeadsBoard } from "./leads";
import { initLeadReport } from "./reports";
import { initGlobalSearch } from "./search";
import { initAiChat } from "./ai-chat";
import { initWhatsApp } from "./whatsapp";
import { initRichText } from "./richtext";
import { registerNotifications } from "./notifications";
import { initReauth } from "./reauth";

declare global {
  interface Window {
    Alpine: typeof Alpine;
  }
}

registerShell(Alpine);
registerSignature(Alpine);
registerDatepicker(Alpine);
registerNotifications(Alpine);

window.Alpine = Alpine;
Alpine.start();

// Non-Alpine DOM enhancements. main.js is deferred, so the DOM is already parsed.
initLeadSections();
initLeadsBoard();
initLeadReport();
initGlobalSearch();
initAiChat();
initWhatsApp();
initRichText();
initReauth();

// Auto-dismiss success alerts (TempData "Msg") after 5s with a short fade-out.
document.querySelectorAll<HTMLElement>(".alert-ok").forEach((el) => {
  window.setTimeout(() => {
    el.style.transition = "opacity .4s ease";
    el.style.opacity = "0";
    window.setTimeout(() => el.remove(), 400);
  }, 5000);
});
